import React from 'react'
import Dialog from 'material-ui/Dialog'
import { Field, reduxForm } from 'redux-form'
import { TextField } from 'redux-form-material-ui'
import { required, money } from '../../form/validation'
import FlatButton from 'material-ui/FlatButton'
import Send from 'material-ui/svg-icons/content/send'
import { themeColors } from '../../styles/theme'

const AddMoneyForm = reduxForm({
  form: 'add-money-form',
})(({ handleSubmit, pristine, reset, submitting, toggleOpen }) => (
  <form onSubmit={handleSubmit}>
    <div>
      <Field
        name="money"
        component={TextField}
        disabled={submitting}
        validate={[required, money]}
        hintText="Denaro"
        floatingLabelText="Aggiungi denaro"
        fullWidth={true}
      />
    </div>
    <div style={{ overflow: 'auto', marginTop: '40px' }}>
      <FlatButton
        type="submit"
        disabled={submitting}
        label="OK"
        primary={true}
        icon={<Send />}
        style={{ float: 'right', marginRight: 10 }}
      />
      <FlatButton
        type="button"
        label="Annulla"
        secondary={true}
        onClick={toggleOpen}
        style={{ float: 'left', marginLeft: 10 }}
      />
    </div>
  </form>
))

const AddMoneyModal = ({
  open,
  onRequestClose,
  initialMoney = 0,
  onMoneyAdded,
}) => {
  return (
    <Dialog
      title="Aggiungi denaro allo scambio"
      titleStyle={{ backgroundColor: themeColors.lightBackground }}
      modal={false}
      open={open}
      contentClassName="fullwidth-for-small"
      titleClassName="SmallModal_title"
      onRequestClose={onRequestClose}>
      <AddMoneyForm
        initialValues={{ money: initialMoney > 0 ? initialMoney : undefined }}
        toggleOpen={onRequestClose}
        onSubmit={({ money }) => {
          onMoneyAdded(money)
          onRequestClose()
        }}
      />
    </Dialog>
  )
}

export default AddMoneyModal



// WEBPACK FOOTER //
// ./src/common/Swap/AddMoneyModal.js